import HexLegend from './HexLegend';

export const all_protos = Object.assign(
    { 'FILL_WITH_OUTLINE' : HexLegend}
)